import React from "react";

const Lead = ({ block }) => (
  <section>
    <div className="shell">
      <div className="prose max-w-none">
        <div className="text-xl md:font-bold" dangerouslySetInnerHTML={{ __html: block.text, }}/>
      </div>
    </div>
  </section>
);

export default Lead;